import React, { Component, Fragment, createRef } from 'react';
import { Link } from 'react-router-dom';
import "../../../config/cssDTB/buttonsDTB.css";
import ConfDtb from "../../../config/confDtb";
import { dataMahasiswa, dropdownAngkatan, dropdownStatus, dropdownJalur } from '../../../dummy-data/mahasiswa';
import { dataProdi } from '../../../dummy-data/prodi';
import { dataTahunAkademik, dataSemester } from '../../../dummy-data/akademik';
const $ = require("jquery");
$.Datatable = require("datatables.net");

class DataMahasiswa extends Component {
    constructor() {
        super()
        this.state = {
            listAngkatan: dropdownAngkatan,
            listProdi: dataProdi.map(p => ({ ijur: p.prodi_id, nmjur: p.prodi_nama })),
            listJalur: dropdownJalur.map(j => ({ idjl: j.value, nmjl: j.label })),
            listSiswa: [],
            listTA: dataTahunAkademik.map(t => ({ ajaran: t.tahun_akademik })),
            listSemester: dataSemester.map(s => ({ nama_semester: s.semester_nama })),
            prodi: '',
            thn_angkatan: '',
            jalur: '',
            sts: '',
            formdata: {
                tgllulus: '',
                smtta_lulus: '',
                ta_lulus: '',
                semester_lulus: ''
            }
        };
        this.closeEditModal = createRef();
    }

    handleChange = (e) => {
        this.setState({
            formdata: {
                ...this.state.formdata,
                [e.target.name]: e.target.value
            }
        })
    }

    // cari data mahasiswa
    SearchMhsClick = (event) => {
        event.preventDefault();
        this.SearchMahasiswa()
    }

    parserText = (val) => {
        var txt = document.createElement("textarea");
        txt.innerHTML = val;
        return txt.value;
    }

    SearchMahasiswa = () => {
        $('#tabel').DataTable().destroy();
        document.getElementById("btn-cari-mhs").disabled = true
        document.getElementById("loaderMhs").style.display = "block";
        document.getElementById("tabel").style.display = "none";

        // Simulate loading delay
        setTimeout(() => {
            // Filter data mahasiswa berdasarkan kriteria
            let filtered = [...dataMahasiswa];

            if (this.state.prodi) {
                filtered = filtered.filter(m => m.prodi_id === parseInt(this.state.prodi));
            }
            if (this.state.thn_angkatan) {
                filtered = filtered.filter(m => m.angkatan === parseInt(this.state.thn_angkatan));
            }
            if (this.state.jalur) {
                filtered = filtered.filter(m => m.jalur === this.state.jalur);
            }
            if (this.state.sts) {
                const statusMap = {
                    '1': 'Aktif',
                    '2': 'Cuti',
                    '3': 'Lulus',
                    '4': 'Non-Aktif',
                    '0': 'DO'
                };
                filtered = filtered.filter(m => m.status === statusMap[this.state.sts]);
            }

            // Map to expected format
            const mappedData = filtered.map(m => ({
                icm: m.mhs_id,
                nim: m.nim,
                nmmw: m.nama,
                stkt: m.status
            }));

            this.setState({
                listSiswa: mappedData,
            });

            ConfDtb();
            document.getElementById("btn-cari-mhs").disabled = false;
            document.getElementById("loaderMhs").style.display = "none";
            document.getElementById("tabel").style.display = "block";
        }, 500);
    }

    // handle untuk perubahan value input by name
    InputChange = (event) => {
        event.preventDefault();
        this.setState({
            [event.target.name]: event.target.value,
        });

        if (event.target.name === 'jalur') {
            this.setState({
                isEksekutif: event.target.options[event.target.selectedIndex].text === 'Malam' ? true : false
            })
        }
    };

    detailModal = (detail) => {
        this.setState({
            nama_mahasiswa: detail.nmmw,
            nim_mahasiswa: detail.nim,
            formdata: {
                tgllulus: '',
                ta_lulus: '',
                smtta_lulus: '',
                semester_lulus: ''
            }
        })
    }

    handleLulus = (e) => {
        e.preventDefault()
        // Simulate save - just close modal
        alert('Data berhasil disimpan! (Demo Mode)');
        this.closeEditModal.current.click();
    }

    componentDidMount = () => {
        // Enable dropdowns immediately since we use static data
        setTimeout(() => {
            if (document.getElementById("prodi") != null) {
                document.getElementById("prodi").disabled = false
            }
            if (document.getElementById("loaderProdi") != null) {
                document.getElementById("loaderProdi").classList.add("sembunyi")
            }
            if (document.getElementById("angkatan") != null) {
                document.getElementById("angkatan").disabled = false
            }
            if (document.getElementById("loaderAngkatan") != null) {
                document.getElementById("loaderAngkatan").classList.add("sembunyi")
            }
            if (document.getElementById("jalur") != null) {
                document.getElementById("jalur").disabled = false
            }
            if (document.getElementById("loaderJalur") != null) {
                document.getElementById("loaderJalur").classList.add("sembunyi")
            }
        }, 300);

        ConfDtb();
    };

    render() {
        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data Mahasiswa
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row" id="smoothMain">
                    <div className="col-xl-12">
                        <div className="card card-custom mb-3 pr-3 pl-3">
                            <div className="card-body">
                                <form onSubmit={this.SearchMhsClick}>
                                    <div className="row">
                                        <div className="col-md-4 mt-2 mb-2">
                                            <label style={{ fontSize: "14px" }}>Prodi :</label>
                                            <div id="loaderProdi" className="loaderInput">
                                                <p align="right">
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                </p>
                                            </div>
                                            <select className="form-control" name="prodi" required
                                                placeholder="prodi" onChange={this.InputChange} id="prodi" disabled>
                                                <option value="">- pilih prodi -</option>
                                                {
                                                    this.state.listProdi.map((prodi, index) => {
                                                        return (
                                                            <option key={index} value={prodi.ijur}>
                                                                {prodi.nmjur}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-4 mt-2 mb-2">
                                            <label style={{ fontSize: "14px" }}>
                                                Tahun angkatan :
                                            </label>
                                            <div id="loaderAngkatan" className="loaderInput">
                                                <p align="right">
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                </p>
                                            </div>
                                            <select className="form-control" name="thn_angkatan" required
                                                placeholder="prodi" onChange={this.InputChange} id="angkatan" disabled>
                                                <option value="">- pilih angkatan -</option>
                                                {
                                                    this.state.listAngkatan.map((angkatan, index) => {
                                                        return (
                                                            <option key={index} value={angkatan.value}>
                                                                {angkatan.label}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-4 mt-2 mb-2">
                                            <label style={{ fontSize: "14px" }}>Status :</label>
                                            <select
                                                className="form-control selectCust"
                                                name="sts"
                                                onChange={this.InputChange}
                                            >
                                                <option value="">- pilih -</option>
                                                <option value="1">Aktif</option>
                                                <option value="2">Cuti</option>
                                                <option value="3">Lulus/Yudisium</option>
                                                <option value="4">Non Aktif</option>
                                                <option value="5">Meninggal</option>
                                                <option value="6">Keluar</option>
                                                <option value="7">Sudah Ujian</option>
                                                <option value="0">Drop Out (DO)</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4 mt-2 mb-2">
                                            <label style={{ fontSize: "14px" }}>Jalur :</label>
                                            <div id="loaderJalur" className="loaderInput">
                                                <p align="right">
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                </p>
                                            </div>
                                            <select id="jalur" className="form-control selectCust"
                                                name="jalur"
                                                onChange={this.InputChange}
                                            >
                                                <option value="">- pilih -</option>
                                                {
                                                    this.state.listJalur.map((jalur, index) => {
                                                        return (
                                                            <option key={index} value={jalur.nmjl}>
                                                                {jalur.nmjl}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-8 mt-2 mb-2">
                                            <p align="right">
                                                <button
                                                    id="btn-cari-mhs"
                                                    className="btn btn-success btn-md"
                                                    style={{ borderRadius: "5px", marginTop: "28.5px" }}
                                                    type="submit"
                                                >
                                                    cari mahasiswa
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card card-custom">
                            <div className="card-body">
                                <p
                                    className="card-title text-center mb-3"
                                    style={{ fontSize: "25px", marginTop: "10px" }}
                                >
                                    Data Mahasiswa
                                </p>
                                <div id="loaderMhs" style={{ display: 'none', marginTop: '80px' }}>
                                    <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                        <div className="dot" />
                                        <div className="dot" />
                                        <div className="dot" />
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table
                                        id="tabel"
                                        className="display expandable-table table-striped"
                                        style={{ width: "100%" }}
                                    >
                                        <thead>
                                            <tr>
                                                <th>No</th>
                                                <th>NIM</th>
                                                <th>Nama</th>
                                                <th>Status</th>
                                                <th>Aksi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.listSiswa.map((mhs, index) => {
                                                    return (
                                                        <tr className="dark" key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{mhs.nim}</td>
                                                            <td style={{ textTransform: 'uppercase' }}>{this.parserText(mhs.nmmw)}</td>
                                                            <td>{mhs.stkt}</td>
                                                            <td>
                                                                <Link
                                                                    target={"_blank"}
                                                                    type="button"
                                                                    className="btn btn-primary ml-2 mt-1"
                                                                    to={`data-mahasiswa/biodata?id=${mhs.icm}&nim=${mhs.nim}`}
                                                                    style={{ padding: "10px 15px 10px 15px", borderRadius: '5px' }}
                                                                    onClick={() => {
                                                                        localStorage.setItem('grub_id', this.props.grub_id);
                                                                    }}
                                                                >
                                                                    detail
                                                                </Link>
                                                                &nbsp;
                                                                <Link
                                                                    to="#"
                                                                    data-toggle="modal"
                                                                    data-target="#detailLulus"
                                                                    onClick={() => this.detailModal(mhs)}
                                                                    type="button"
                                                                    className="btn btn-info ml-2 mt-1"
                                                                    style={{ padding: "10px 15px 10px 15px", borderRadius: '5px' }}
                                                                >
                                                                    set lama studi
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* detail lulus per mahasiswa */}
                    <div className="modal fade" id="detailLulus" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-md" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title" id="exampleModalLabel">Set Lama Studi </h4>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeEditModal}>
                                        <span aria-hidden="true" className="close-btn">×</span>
                                    </button>
                                </div>
                                <div className="modal-body" >
                                    <div className="">
                                        <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td width="50px">Nama</td>
                                                    <td width="5px"> : </td>
                                                    <td width="200px">{this.state.nama_mahasiswa}</td>
                                                </tr>
                                                <tr>
                                                    <td>NIM</td>
                                                    <td> : </td>
                                                    <td>{this.state.nim_mahasiswa}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <form onSubmit={this.handleLulus}>
                                            <div className="row">
                                                <div className="col-md-6 mt-2 mb-2">
                                                    <label style={{ fontSize: "14px" }}>Tanggal lulus :</label>
                                                    <input type="date" className='form-control' onChange={this.handleChange} name="tgllulus"
                                                        value={this.state.formdata.tgllulus} required></input>
                                                </div>
                                                <div className="col-md-6 mt-2 mb-2">
                                                    <label style={{ fontSize: "14px" }}>
                                                        Tahun Akademik :
                                                    </label>
                                                    <select className="form-control" name="ta_lulus" value={this.state.formdata.ta_lulus} required
                                                        placeholder="prodi" onChange={this.handleChange} id="ta_lulus" >
                                                        <option value="" hidden>-</option>
                                                        {this.state.listTA.map((list, i) => {
                                                            return (
                                                                <option key={i} value={list.ajaran}>{list.ajaran}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-md-6 mt-2 mb-2">
                                                    <label style={{ fontSize: "14px" }}>
                                                        Ganjil / Genap :
                                                    </label>
                                                    <select className="form-control" name="smtta_lulus" value={this.state.formdata.smtta_lulus} required
                                                        placeholder="smtta" onChange={this.handleChange} id="smtta_lulus" >
                                                        <option value="" hidden>-</option>
                                                        <option value="1" >ganjil</option>
                                                        <option value="2" >genap</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-6 mt-2 mb-2">
                                                    <label style={{ fontSize: "14px" }}>
                                                        Semester :
                                                    </label>
                                                    <select className="form-control" name="semester_lulus" value={this.state.formdata.semester_lulus} required
                                                        placeholder="smtta" onChange={this.handleChange} id="semester_lulus" >
                                                        <option value="" hidden>-</option>
                                                        {this.state.listSemester.map((list, i) => {
                                                            return (
                                                                <option key={i} value={list.nama_semester}>{list.nama_semester}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-md-12 mt-2 mb-2">
                                                    <p align="right">
                                                        <button
                                                            id="btn-cari-mhs"
                                                            className="btn btn-success btn-md"
                                                            style={{ borderRadius: "5px", marginTop: "28.5px" }}
                                                            type="submit"
                                                        >
                                                            simpan
                                                        </button>
                                                    </p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* detail lulus  per mahasiswa */}

                </div>
            </Fragment>
        );
    }
}

export default DataMahasiswa;
